import { FULL_DEAL_VITRIN_URLS_SET } from '@src/constants/fullDeal';

export const checkIsFullDealBlockVisible = (path: string) => FULL_DEAL_VITRIN_URLS_SET.has(path);
